import NotFound from 'components/NotFound/NotFound';
import { useCompanyInvestorUpdateTemplate } from 'hooks/useInvestorUpdateTemplate';
import { useDeleteUpdateTemplateMetadataMutation } from 'hooks/useInvestorUpdateTemplate';
import { useCompanyInvestorUpdateTemplateById } from 'hooks/useInvestorUpdateTemplate';
import React from 'react'
import { HiOutlinePlusCircle } from 'react-icons/hi';
import { Link, NavLink } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Button, Card, Col, Container, Form, Table, Row, Badge } from "reactstrap";
export default function InvestorUpdateTemplateList() {
    React.useEffect(() => {
        localStorage.setItem("investor_update_template_id", "")
    }, [])
    const { mutate: deleteInvestorUpdate } = useDeleteUpdateTemplateMetadataMutation()
    const onRemoveInvestorUpdate = async (id) => {
        let confirm = window.confirm("Are sure you want to trash this property?");
        if (confirm) {
            await deleteInvestorUpdate(id, {
                onSuccess: (res) => {
                    toast.success('Investor Update Delete Successfully')
                }
            })
        }
    };
    const { data } = useCompanyInvestorUpdateTemplate({
        property_id: localStorage.getItem("property_id")
    });

    return (
        <>
            <Row className="my-2">
                <Col>
                    <h3 className='rz-heading rz-text-18'>Templates Management</h3>
                </Col>
                <Col className="text-right">
                    <NavLink
                        onClick={() => {
                            localStorage.setItem("update_redirect", 2);
                        }}
                        to={{
                            pathname: `/company/createInvestOrUpdate`
                        }}
                        className="btn btn-primary">
                        <HiOutlinePlusCircle className='mr-2' style={{ fontSize: "22px" }} /> Create New
                    </NavLink>
                </Col>
            </Row>
            <Card>
                <Table className='mt-3' responsive>
                    <thead className="rz-thead-style">
                        <tr>
                            <th>TITLE</th>
                            <th>STATUS</th>
                            <th>SENT AT</th>
                            <th className="text-right">ACTIONS</th>
                        </tr>
                    </thead>

                    <tbody>
                        {data && data?.map((update) => (
                            <tr>
                                <td>
                                    {update?.heading}
                                </td>
                                <td>
                                    <Badge
                                        color=""
                                        className={`badge badge-pill badge-${update?.status == "ACTIVE"
                                            ? "success"
                                            : "primary"
                                            } mr-4`}
                                    >
                                        {update?.status}
                                    </Badge>
                                </td>
                                <td>{new Date(update?.created_at).toDateString()}</td>
                                <td className="text-right">
                                    <Link
                                        onClick={() => {
                                            localStorage.setItem("update_redirect", 2);
                                            localStorage.setItem("investor_update_template_id", update?.id)
                                        }}
                                        to={`/company/createInvestOrUpdate`}
                                        className="btn btn-sm btn-link bg-transparent"
                                    >
                                        <i className="fa fa-edit"></i>
                                    </Link>

                                    <Button
                                        onClick={() => onRemoveInvestorUpdate(update?.id)}
                                        className="btn btn-sm btn-link text-danger bg-transparent border-0"
                                    >
                                        <i className="fas fa-trash    "></i>
                                    </Button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
                {data?.length <= 0 &&
                    <NotFound
                        message="Create first update for this property."
                    />
                }
            </Card>
        </>
    )
}
